"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerMetricsType = void 0;
var CustomerMetricsType;
(function (CustomerMetricsType) {
    CustomerMetricsType["CustomerBase"] = "Customer Base";
    CustomerMetricsType["GrossAdds"] = "Gross Adds";
    CustomerMetricsType["Churn"] = "Churn";
})(CustomerMetricsType || (exports.CustomerMetricsType = CustomerMetricsType = {}));
